module.exports = __webpack_public_path__ + "static/media/fuhuaxiangmukaifaliucheng.d37e58ff.png";